// extracted by mini-css-extract-plugin
module.exports = {"container":"popover_loading-module__container--3kPG7","loader":"popover_loading-module__loader--1HPWr"};